import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-warn-for-permission-dialog',
  templateUrl: './warn-for-permission-dialog.component.html',
  styleUrls: ['./warn-for-permission-dialog.component.scss']
})
export class WarnForPermissionDialogComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  nextStep() {
    this.router.navigateByUrl('scan/step2', { replaceUrl: true });
  }

}
